const Warning = ({children}) => {
    return <div className="warning">{children}</div>;
};

export default Warning;